/* class decorator */
function staticImplements<T>() {
    // eslint-disable-next-line
    return <U extends T>(_: U) => {};
}

export default staticImplements;
